export default __webpack_public_path__ + "static/media/newfog1.6e997362.png";